import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * 高阶商务浅色布局：克制留白 + 钢蓝主色
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#1b4f8c',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: 'AI智慧监控平台',
  pwa: true,
  logo: '/logo-glow.png',
  iconfontUrl: '',
  token: {
    bgLayout: '#f2f4f8',
    header: {
      colorBgHeader: 'rgba(255,255,255,0.92)',
      colorHeaderTitle: '#0b1526',
      colorTextMenu: 'rgba(11,21,38,0.65)',
      colorTextMenuSecondary: 'rgba(11,21,38,0.45)',
      colorTextMenuSelected: '#1b4f8c',
      colorBgMenuItemSelected: 'rgba(27, 79, 140, 0.08)',
      colorTextMenuActive: '#1b4f8c',
      colorBgMenuItemHover: 'rgba(27, 79, 140, 0.05)',
      heightLayoutHeader: 56,
    },
    sider: {
      colorMenuBackground: '#ffffff',
      colorMenuItemDivider: 'transparent',
      colorBgMenuItemHover: 'rgba(27, 79, 140, 0.05)',
      colorBgMenuItemSelected: 'rgba(27, 79, 140, 0.09)',
      colorTextMenu: 'rgba(11,21,38,0.68)',
      colorTextMenuSelected: '#1b4f8c',
      colorTextMenuActive: '#1b4f8c',
      colorTextMenuItemHover: '#1b4f8c',
      colorBgMenuItemCollapsedElevated: '#ffffff',
    },
    pageContainer: {
      paddingBlockPageContainerContent: 20,
      paddingInlinePageContainerContent: 24,
      colorBgPageContainer: 'transparent',
    },
  },
};

export default Settings;
